import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SummaryInformationContainer = styled(Box)(({ theme }) => ({
  marginTop: '24px',
  fontFamily: theme.typography.fontFamily,
}));

export const SummarySectionContainer = styled(Box)(({ theme }) => ({
  '& + &': {
    marginTop: '24px',
  },

  '& .section-title': {
    fontSize: theme.typography.h6.fontSize,
  },

  '& .divider': {
    marginTop: '8px',
    marginBottom: '16px',
  },

  '& .text': {
    color: 'rgba(0, 0, 0, 0.87)',
  },

  '& .text-label': {
    fontFamily: theme.typography.fontFamily,
    fontSize: '18px',
    lineHeight: 1.375,
  },

  '& .main-info': {
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '22px',
    color: 'rgba(0, 0, 0, 0.6)',
  },

  '& .text-value': {
    fontFamily: 'Lanna',
    fontSize: '18px',
  },

  '& .summary-section-subtitle': {
    fontFamily: 'Lanna',
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '18px',
    fontWeight: '400',
    lineHeight: '22px',
  },
}));
